export const APP_VERSION = '176ce1a'; // to be replaced during build

const hostname = window.location.hostname;
const isProd = window.location.hostname.endsWith('voltasoftware.it');
const isStaging = window.location.hostname.endsWith('volta-software.it');
const protocol = window.location.protocol.replace(':', '');

const VOLTA_DOMAINS = ['.volta-software.com', '.volta-software.it', '.voltasoftware.it'];

const isVoltaHost = (host: string) => VOLTA_DOMAINS.some((domain) => host.endsWith(domain));

/**
 * Maps a portal host to its backend host. Both the legacy `tenant-bo.<domain>`
 * and the plain `tenant.<domain>` resolve to `tenant-backend.<domain>`, which is
 * also the Odoo database name — dbfilter matches on the host.
 */
export const toBackendHost = (host: string) => {
  if (host.includes('-bo.')) {
    return host.replace('-bo.', '-backend.');
  }
  const [tenant, ...rest] = host.split('.');
  return [`${tenant}-backend`, ...rest].join('.');
};

export const resolveBaseUrl = (host: string, scheme: string) => {
  if (host === 'localhost' || host === '127.0.0.1') { // Dev env
    return 'http://localhost:8069';
  }
  if (host.endsWith('.local') || host.endsWith('.localhost')) { // Local DNS tests
    return `${scheme}://${toBackendHost(host)}:8069`;
  }
  if (isVoltaHost(host)) {
    return `${scheme}://${toBackendHost(host)}`;
  }
  // Unknown domain (IP, custom domain): keep the origin as-is.
  return `${scheme}://${host.replace('-bo.', '-backend.')}`;
};

const BASE_URL = resolveBaseUrl(hostname, protocol);

export const environment = {
  production: isProd || isStaging,
  env_name: isProd ? 'PROD' : isStaging ? 'STAGING' : 'DEV',
  BASE_URL: BASE_URL,
  BASE_URL_API : BASE_URL + '/v1/',

  // Hotjar config
  HOTJAR_SITE_ID: 6365528,
  HOTJAR_VERSION: 6,
  HOTJAR_ENABLED: true,
  HOTJAR_DEBUG: true,

  /** When true, services will uses mock data if present instead of API. */
  useMockData: false,

  /**
   * When true, AI chat uses POST /v1/ai/chat/stream (SSE). When false, POST /v1/ai/chat (JSON).
   * Keep disabled for now, till chat stream is fixed.
   */
  aiChatUseStream: false,
  
  // ── Maintenance ───────────────────────────────────────────────────────────
  /** When true, show the maintenance screen instead of the app UI. */
  maintenanceMode: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
